import selectableColumnType from "@harbor/elements/utils/table/columnTypes/selectable";
import { generatePath } from "react-router-dom";
import { tableCellSelection, tableColumnSelection } from "../../../../common/adUtils";
import appStore from '../../../../../../../../store';
import { routeURLs } from "../../../../../../../../utils/enums";
import { tViews } from "../../../../../../../../utils/table";

const getColumns = ({ store, openTableSettings }) => {
  return [
        {
          id: "selectable_col",
          headerSlot: false,
          hiddenText: tViews('selectAll'),
          ...selectableColumnType({
            testId: (props) => `checkbox-${props.model.id}`,
            store,
            ariaLabel: (props) => tViews('selectCircuitwithCircuitName', {circuitName: props.model.display_circuit_name}),
          }),
          columnTemplate: (createElement) => {
            return tableColumnSelection(createElement, store);
          },
          cellTemplate: (createElement, props) => {
            if(props.model.availability !== "-")
              return tableCellSelection(createElement, props, store);
          }
        },
        {
          id: "display_circuit_name_col",
          prop: "display_circuit_name",
          get name() { return tViews('usgCircuitTrendAvailTable.column_label.circuitName')},
          sortable: true,
          size: 180,
          cellTemplate: (createElement, prop) => {
            let globalStore = appStore.getState().vanalytics.app.globalFilter
            let rowData = globalStore.circuitsMasterTable?.data?.find((item) => item.circuit_display_name === prop.model.display_circuit_name);
            return createElement("hbr-link",
            {
              "onClick": (e) => {
                e.preventDefault();
                if (rowData.circuit_display_name) {
                  localStorage.setItem(
                    "circuit",
                    JSON.stringify({
                      ...rowData,
                      overlay: localStorage.getItem("currentOverlay")
                    }));
                  const circuitName = rowData.circuit_display_name.split(":").join("~");
                  window.location.href = generatePath(routeURLs.circuit360, { circuitName });
                }
              },
              "aria-label": tViews('viewDetailswithCircuitName', {circuitName: prop.model.display_circuit_name}),
              "data-testid": "circuit-trend-circuit-link",
              "onKeyDown": (e) => {
                // Trigger action on Enter or Space key
                if (e.key === 'Enter' || e.key === ' ') {
                  if (rowData.circuit_display_name) {
                    localStorage.setItem(
                      "circuit",
                      JSON.stringify({
                        ...rowData,
                        overlay: localStorage.getItem("currentOverlay")
                      }));
                    const circuitName = rowData.circuit_display_name.split(":").join("~");
                    window.location.href = generatePath(routeURLs.circuit360, { circuitName });
                  }
                }
              },
              role: "link"
            }, prop.model.display_circuit_name);
          }
        },
        {
          id: "local_service_provider_col",
          prop: "local_service_provider",
          get name() { return tViews('usgCircuitTrendAvailTable.column_label.serviceProvider')},
          sortable: true,
          size: 100
        },
        {
          id: "site_name_col",
          prop: "site_name",
          get name() { return tViews('usgCircuitTrendAvailTable.column_label.site')},
          sortable: true,
          size: 100
        },
        {
          id: "tloc_state_col",
          prop: "tloc_state",
          get name() { return tViews('usgCircuitTrendAvailTable.column_label.tlocState')},
          sortable: true,
          size: 100
        },
        {
          id: "site_city_col",
          prop: "site_city",
          get name() { return tViews('usgCircuitTrendAvailTable.column_label.location')},
          sortable: true,
          size: 100
        },
        {
          id: "availability_col",
          prop: "availability",
          get name() { return tViews('usgCircuitTrendAvailTable.column_label.availability')},
          sortable: true,
          size: 130
        },
        {
          id: "downtime_col",
          prop: "display_downtime",
          get name() { return tViews('usgCircuitTrendAvailTable.column_label.downtime')},
          sortable: true,
          size: 100
        },
        {
          id: "display_circuit_usage_col",
          prop: "display_circuit_usage",
          get name() { return tViews('usgCircuitTrendAvailTable.column_label.displayCircuitUsage')},
          sortable: true,
          size: 150
        },
        {
          id: "display_tunnel_usage_col",
          prop: "display_tunnel_usage",
          get name() { return tViews('usgCircuitTrendAvailTable.column_label.displayTunnelUsage')},
          sortable: true,
          size: 150
        },
        {
          id: "display_dia_usage_col",
          prop: "display_dia_usage",
          get name() { return tViews('usgCircuitTrendAvailTable.column_label.displayDIAUsage')},
          sortable: true,
          size: 130
        },
        {
          id: "display_sig_usage_col",
          prop: "display_sig_usage",
          get name() { return tViews('usgCircuitTrendAvailTable.column_label.displaySIGUsage')},
          sortable: true,
          size: 130
        },
        {
          id: "app_cnt_col",
          prop: "app_cnt",
          get name() { return tViews('usgCircuitTrendAvailTable.column_label.apps')},
          sortable: true,
          size: 120
        },
        {
          id: "actions_col",
          prop: "actions",
          name: "Actions",
          hiddenText: "Actions",
          disableToggle: true,
          sortable: false,
          headerSlot: false,
          pin: "colPinEnd",
          size: 70,
          columnTemplate: (createElement) => {
            return createElement("hbr-icon-button", {
              name: "gear-six-outlined",
              class: "hbr-css__table-cell-align-center gear-icon",
              "data-testid": "setting-ad-circuit-availability-table",
              onClick: (evt) => {
                evt.stopPropagation();
                openTableSettings();
              }
            });
          }
        }
    ]
}

export default getColumns;
